import axios from 'axios';
import Config from '../config/environments';
import validation from './validation';
import { checkIdle } from '../service/user';
import authorization from './authorization';

const baseURL = Config.END_POINT;

const baseRequest = {
  baseURL,
  withCredentials: true,
  timeout: 0,
  headers: {
    'Content-Type': 'application/json',
  },
};

const baseLogin = {
  baseURL,
  withCredentials: true,
  timeout: 0,
  headers: {
    'Content-Type': 'application/json',
  },
};

const axiosInstance = axios.create(baseRequest);
const axiosLogin = axios.create(baseLogin);

const checkingInterceptor = (config) => {
  checkIdle();
  validation(config.response);
  return config;
};

axiosInstance.interceptors.response.use(validation, checkingInterceptor);
axiosInstance.interceptors.request.use(authorization);
axiosLogin.interceptors.response.use(validation, validation);

export { axiosInstance, axiosLogin };
